
export const common = {
  'call.us': 'התקשר אלינו',
  'privacy.policy': 'מדיניות פרטיות',
  'select.location': 'בחר את מיקומך',
  'location.description': 'בחר את מיקומך כדי להתקשר למספר המתאים',
  'usa': 'ארה"ב',
  'non.usa': 'מחוץ לארה"ב שיחה או WhatsApp',
  'documents.downloads': 'מסמכים והורדות',
  'item': 'פריט',
  'value': 'ערך',
  'price': 'מחיר',
  'product': 'מוצר',
  'msrp': 'מחיר מומלץ לצרכן',
};
